module.exports = __webpack_public_path__ + "static/lageplan_auto_mini-a93bbff289e19dafb6e1ca038b7dfe32.png";